import Vue from 'vue';
import Vuex from 'vuex';

const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      name: '', //用户昵称/电话
      user_id: '',
      coupon_name: '', //优惠卷名称
      used_start_at: '',
      used_end_at: ''
    }
  },
  downData: []
};

const mutations = {
  changeMerchantCouponPage(state, val) {
    state.params = val;
  },
  changeMerchantCouponDownList(state, val) {
    state.downData = val;
  }
};

export default {
  state,
  mutations
};
